import React from 'react';
import { motion } from 'framer-motion';

const testimonialData = [
    {
        id: 1,
        quote: "The craftsmanship and elegance exceeded my expectations. A true gem in my collection. Highly recommended for timeless beauty.",
        name: "Woodrow Trusty",
        role: "Customer",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop"
    },
    {
        id: 2,
        quote: "The craftsmanship and elegance exceeded my expectations. A true gem in my collection. Highly recommended for timeless beauty.",
        name: "Woodrow Trusty",
        role: "Customer",
        avatar: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=150&auto=format&fit=crop"
    }
];

const LeadershipCommitment = () => {
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.15 }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" }
        }
    };

    return (
        <section className="w-full bg-[#FFFFFF] pb-16 lg:pb-24 overflow-hidden select-none text-left">
            <div className="max-w-[1440px] w-full mx-auto px-[20px] lg:px-[80px]">

                <div className="w-full text-center mb-[40px] lg:mb-[60px]">
                    <h2 className="text-[#01386A] text-[20px] lg:text-[30px] font-[600] tracking-tight font-sora">
                        Leadership Commitment
                    </h2>
                </div>

                <motion.div
                    variants={containerVariants}
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true, amount: 0.2 }}
                    className="grid grid-cols-1 md:grid-cols-2 gap-[10px] xl:gap-[18px] w-full items-stretch"
                >
                    {testimonialData.map((item) => (
                        <motion.div
                            key={item.id}
                            variants={cardVariants}
                            whileHover={{ y: -6, scale: 1.01 }}
                            transition={{ type: "spring", stiffness: 200, damping: 22 }}
                            className="w-full bg-white flex flex-col justify-between min-h-[280px] border border-[#BAC9D7] rounded-none cursor-pointer relative p-6 sm:p-10 pb-8 sm:pb-12 group"
                        >
                            <div className="absolute bottom-0 left-0 right-0 h-[4px] bg-[#01386A] z-10" />

                            <div className="absolute bottom-0 left-0 w-0 h-[4px] bg-[#ED6800] z-20 transition-all duration-500 ease-out group-hover:w-full" />

                            <div className="w-full relative mb-8 z-30">
                                <span className="text-[#49577A] text-[40px] font-serif leading-none absolute -top-4 -left-1 select-none opacity-40">
                                    “
                                </span>
                                <p className="text-[#49577A] text-[14px] sm:text-[16px] leading-relaxed font-[500] font-graphik pl-6 relative z-10">
                                    {item.quote}
                                </p>
                                <span className="text-[#49577A] text-[40px] font-serif leading-none absolute -bottom-8 inline-block select-none opacity-40">
                                    ”
                                </span>
                            </div>

                            <div className="w-full flex items-center gap-4 mt-4 z-30">
                                <div className="w-14 h-14 rounded-full overflow-hidden bg-gray-50 border border-gray-100 shrink-0">
                                    <img
                                        src={item.avatar}
                                        alt={item.name}
                                        className="w-full h-full object-cover"
                                    />
                                </div>
                                <div className="flex flex-col items-start gap-0.5">
                                    <h4 className="text-[#01386A] font-[600] font-sora text-[16px] lg:text-[20px] tracking-tight">
                                        {item.name}
                                    </h4>
                                    <span className="text-[#49577A] font-graphik text-[14px] lg:text-[16px] font-[500] tracking-wider">
                                        {item.role}
                                    </span>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </motion.div>

            </div>
        </section>
    );
};

export default LeadershipCommitment;